<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal success_popup" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <!-- <div class="modal_close_btn">
        <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
      </div> -->
      <!-- Modal content-->
      <div mat-dialog-content>
        <!-- Modal-Body -->
        <div class="modal-body br-8">
        <div class="modal_close_btn">
            <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
          </div>  
          <div class="success_details">
            <div class="status_img">
              <img src="../../../../../assets/images/icons/success.svg" alt="" loading="eager">
            </div>
<!-- For SUPPLIER -->
<div class="status_content" *ngIf="data?.type === 'SUPPLIER'; else nonSupplierContent">
  <h4>Register Your Request</h4>
  <p>We’ve received your registration request. Our team will be get back to you as soon as possible
  </p>
</div>

<!-- For Other Types -->
<ng-template #nonSupplierContent>
  <div class="status_content">
    <h4>Sign Up Successful</h4>
    <p>A verification link has been sent to <span>{{data?.email}}</span>.  
      Please click on the link to activate your account and get started.
    </p>
  </div>
</ng-template>

 
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
